import {
  GET_PROJECT_API,
  GET_ROOMS_API,
  OP_GET_PROJECT_API,
  OP_GET_ROOMS_API,
  OP_GET_SORT_ROOMS_API,
  OP_GET_SHARED_PRODUCT_API,
} from '../../config/constant/apiConstant';
import { createDeleteApiAction, createGetListAction, createUpdateApiAction } from '../apiGenerator';

import { GET_INSPIRATION } from '../../helpers/api';
import { MODEL_TYPES } from '../../constants/constants';
import {
  myprojectsActions,
} from '../../redux/slicers/my-projects/myProjectsSlicer';
import { paginatedRoomsActions } from '../../redux/slicers/admin/paginatedRooms';
import { paginatedSharedProductPageActions } from '../../redux/slicers/admin/paginatedSharedProduct';

export const getProjectsApiV2 = createGetListAction({
  endpoint: OP_GET_PROJECT_API, // GET_PROJECT_API,
  actions: myprojectsActions,
  setGlobalSidebarFilters: true,
  useOptimizedAPI: true,
  modelType: MODEL_TYPES.PROJECTS
});

export const projectUpdateApi = createUpdateApiAction({
  actions: myprojectsActions,
  endpointUrl: GET_PROJECT_API,
})

export const deleteProjectAPI = createDeleteApiAction({
  actions: myprojectsActions,
  endpointUrl: GET_PROJECT_API,
  optimistic: false,
  successMessage: 'The File is deleted successfully',
})


export const getRoomsPageListApi = createGetListAction({
  endpoint: GET_ROOMS_API,
  actions: paginatedRoomsActions,
  setGlobalSidebarFilters: true,
});

export const getMyRoomsPageListOptimizeApi = createGetListAction({
  endpoint: OP_GET_ROOMS_API,
  actions: paginatedRoomsActions,
  setGlobalSidebarFilters: true,
  useOptimizedAPI: true,
  modelType: MODEL_TYPES.ROOM,
});

export const getSortMyRoomsPageListOptimizeApi = createGetListAction({
  endpoint: OP_GET_SORT_ROOMS_API,
  actions: paginatedRoomsActions,
  setGlobalSidebarFilters: true,
  useOptimizedAPI: true,
  modelType: MODEL_TYPES.ROOM,
});

export const getSharedProductPageListOptimizeApi = createGetListAction({
  endpoint: OP_GET_SHARED_PRODUCT_API,
  actions: paginatedSharedProductPageActions,
  setGlobalSidebarFilters: false,
  useOptimizedAPI: true,
  modelType: MODEL_TYPES.SHARED_PRODUCT_PAGE,
});

export const getTemplatesPageListOptimizeApi = createGetListAction({
  endpoint: OP_GET_ROOMS_API,
  actions: paginatedRoomsActions,
  setGlobalSidebarFilters: true,
  useOptimizedAPI: true,
  modelType: MODEL_TYPES.TEMPLATES,
});

export const getInspirationsPageListApi = createGetListAction({
  endpoint: GET_INSPIRATION,
  actions: paginatedRoomsActions,
  setGlobalSidebarFilters: true,
});

export const roomUpdateApi = createUpdateApiAction({
  actions: paginatedRoomsActions,
  endpointUrl: GET_ROOMS_API,
})

